import { Attribute, Caption, Headline, Image, SubHeader } from "../../subcomponents/subcomponents";
import Styles from "./view_product.module.css";
export const Product = ( props ) => {
    const { product, product: { image, imageTheme, link, productName, productTheme, rate, rateTheme, teamTitle, teamTitleIcon, teamSection, date, sections, sectionsTheme, sectionsColor } = {} } = props;
    const { Product } = Styles;
    return (
        <div className={ Product }>
            {/*========Info Section========*/}
            { product && <InfoSection
                image         = { image         }
                imageTheme    = { imageTheme    }
                link          = { link          }
                productName   = { productName   }
                productTheme  = { productTheme  }
                rate          = { rate          } 
                rateTheme     = { rateTheme     }
                teamTitle     = { teamTitle     }
                teamTitleIcon = { teamTitleIcon }
                teamSection   = { teamSection   }
            />}
            {/*==========Caption===========*/}
            { sections && <Caption 
                date     = { date          }
                sections = { sections      }
                theme    = { sectionsTheme }
                color    = { sectionsColor }
            />}
        </div>
    );
};
const InfoSection = ( props ) => {
    const { image, imageTheme, link, productName, productTheme, rate, rateTheme, teamTitle, teamTitleIcon, teamSection } = props;
    const { InfoSection } = Styles;
    return (
        <div className={ InfoSection }>
            {/*========Product Image========*/}
            { image && <Image  
                src    = { image      }
                theme  = { imageTheme }
            />}
            {/*========Product Title========*/}
            { productName && <Headline 
                icon    = { <i className="bi bi-feather"></i>                                          }
                text    = { productName                                                                }
                subIcon = { <i className="bi bi-folder-symlink-fill" style={{ color: "#009688" }}></i> }
                link    = { link                                                                       }
                width   = { 400                                                                        }
                theme   = { productTheme                                                               }
            />}
            {/*========Product Rate=========*/}
            { rate && <Headline 
                icon  = { <i className="bi bi-bookmark-star-fill"></i> }
                text  = { rate                                    }
                width = { 400                                     }
                theme = { rateTheme                               }
            />}
            {/*========Product Team========-*/}
            { teamSection && <TeamSection 
                teamTitle     = { teamTitle     }
                teamTitleIcon = { teamTitleIcon }
                team          = { teamSection   }
            />}
        </div>
    );
};
const TeamSection = ( props ) => {
    const { teamTitle, teamTitleIcon, team = [] } = props;
    const { TeamSection } = Styles;
    return (
        <div className={ TeamSection }>
            <SubHeader
                icon = { teamTitleIcon }
                text = { teamTitle     }
            />
            { 
                team.map(( value, key) => {
                    const { name, icon, theme, link } = value;
                    return (
                        <Headline
                            icon  = { icon  }
                            text  = { name  }
                            width = { 400   }
                            theme = { theme }
                            link  = { link  }
                            key   = { key   }
                        />
                    );
                })
            }
        </div>
    );
};